// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"539":"4d782008","595":"ef02fdff","780":"6125e480","818":"4d782008"}[chunkId] + ".chunk.css";
};